<div class="hero">
  <div class="brand">        
    <img src="assets/images/BANNER.png" alt="F1Pro" class="banner">
  </div>
</div>

<div class="container">
  <div class="grid">
    <div class="card">
      <img src="assets/images/f1pro_desc.png" class="img-box">
      <h3>Gestão Vacinal</h3>
      <p>Solução completa para gestão de vacinação, com foco na segurança e eficiência.</p>
      <p>Arquitetura moderna, integrações seguras e documentação clara para acelerar sua operação desde o primeiro dia.</p>
      <a class="cta" href="https://vacina.f1pro.com.br/">Saiba mais</a>
    </div>    
  </div>

  <div class="section-title">Recursos do Aplicativo</div>
  <div class="grid">
    <div class="card">
      <h3>Acesso ao Sistema</h3>
      <ul>
        <li>Login com usuário e senha</li>
        <li>Perfis de acesso por papel</li>
        <li>Fluxos simples e intuitivos</li>
      </ul>
    </div>
    <div class="card">
      <h3>Módulo de Cadastros</h3>
      <ul>
        <li>Cadastro de clientes e dependentes</li>
        <li>Gestão de fornecedores e parceiros</li>
        <li>Base de dados organizada</li>
      </ul>
    </div>
    <div class="card">
      <h3>Módulo Clínico</h3>
      <ul>
        <li>Calendário vacinal e agendamentos</li>
        <li>Registro de aplicações e prontuários</li>
        <li>Fila de atendimento eficiente</li>
      </ul>
    </div>
    <div class="card">
      <h3>Módulo Comercial</h3>
      <ul>
        <li>PDV com carrinho e descontos</li>
        <li>Gestão de estoque e lotes</li>
        <li>Pagamentos: Dinheiro, Cartão, PIX</li>
      </ul>
    </div>
    <div class="card">
      <h3>Módulo Financeiro</h3>
      <ul>
        <li>Contas a pagar e receber</li>
        <li>Fechamento de caixa</li>
        <li>Relatórios gerenciais (DRE)</li>
      </ul>
    </div>
    <div class="card">
      <h3>Configurações e Segurança</h3>
      <ul>
        <li>Permissões e grupos de acesso</li>
        <li>Auditoria e rastreabilidade</li>
        <li>Boas práticas de proteção</li>
      </ul>
    </div>
  </div>

  <div class="footer">© {{year}} F1Pro — Tecnologia que simplifica.</div>
</div>
